"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var CategoryItem1_1 = __importDefault(require("./CategoryItem1"));
var CategoryItem1List = /** @class */ (function (_super) {
    __extends(CategoryItem1List, _super);
    function CategoryItem1List() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CategoryItem1List.prototype.onMouseOver = function (e) {
        if (this.props.onMouseOver) {
            this.props.onMouseOver();
            e.preventDefault();
        }
    };
    CategoryItem1List.prototype.onMouseLeave = function (e) {
        if (this.props.onClose) {
            this.props.onClose();
            e.preventDefault();
        }
    };
    CategoryItem1List.prototype.render = function () {
        var _this = this;
        var _a = this.props, show = _a.show, productCategories = _a.productCategories;
        var rows = productCategories.map(function (productCategory, index) {
            return react_1.default.createElement(CategoryItem1_1.default, __assign({ key: index, productCategory: productCategory }, _this.props));
        });
        var display = 'none';
        if (show) {
            display = 'block';
        }
        return (react_1.default.createElement("div", { className: "categoryFirstLayer", style: { display: display }, onMouseOver: this.onMouseOver.bind(this), onMouseLeave: this.onMouseLeave.bind(this) }, rows));
    };
    CategoryItem1List.propTypes = {
        productCategories: prop_types_1.default.arrayOf(prop_types_1.default.shape({
            name: prop_types_1.default.string.isRequired,
            displayCategoryId: prop_types_1.default.number.isRequired,
            itemCount: prop_types_1.default.number.isRequired,
            disableMarketplaceBanner: prop_types_1.default.bool,
        })).isRequired,
        show: prop_types_1.default.bool.isRequired,
        onClose: prop_types_1.default.func,
    };
    return CategoryItem1List;
}(react_1.default.Component));
exports.default = CategoryItem1List;
